import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  content: {
    textAlign: 'center',
  },
  message: {
    boxShadow: 'rgba(0, 0, 0, 0.56) 0px 22px 70px 4px',
    padding: 30,
    margin: 20,
    textAlign: 'center',
    borderRadius: 5,
    fontWeight: 550,
  },
  title_error: {
    color: '#f00',
    borderRadius: 10,
    padding: 10,
  },
  title_success: {
    color: '#00cc6d',
    borderRadius: 10,
    padding: 10,
  },
  image: {
    width: 400,
  },
  gridImage: {
    textAlign: 'center',
    paddingTop: 50,
  },
}));
